import { fromThreadMessageLike, type AppendMessage, type ThreadMessage, type ThreadMessageLike } from '@assistant-ui/react';
import type { PendingRunInteractionView, ThreadMessageRecordView } from './ChatRuntime';
import type { AgenthubInterrupt } from './agenthubInterrupts';
import { toPersistedMessageLike } from './toThreadMessages';

function toThreadMessage(like: ThreadMessageLike, index: number): ThreadMessage {
  return fromThreadMessageLike(like, like.id ?? `message-${index}`, { type: 'complete', reason: 'stop' });
}

export function persistedRecordsToThreadMessages(records: readonly ThreadMessageRecordView[]): ThreadMessage[] {
  return records.map((record, index) => toThreadMessage(toPersistedMessageLike(record), index));
}

export function pendingInteractionToInterrupt(pending: PendingRunInteractionView): AgenthubInterrupt {
  return {
    id: pending.id,
    reason: pending.type,
    message: (pending.type === 'approval' ? pending.approvalPrompt : pending.question) ?? undefined,
    metadata: {
      data: {
        question: pending.question ?? undefined,
        approval_prompt: pending.approvalPrompt ?? undefined,
        tool_call_id: pending.toolCallId ?? undefined,
        options: pending.options ?? undefined,
        questions: pending.questions ?? undefined,
      },
    },
  };
}

export function appendMessageToThreadMessage(message: AppendMessage): ThreadMessage {
  const { parentId: _parentId, sourceId: _sourceId, runConfig: _runConfig, startRun: _startRun, steer: _steer, ...base } = message;
  return { ...base, id: crypto.randomUUID() } as ThreadMessage;
}
